<mat-drawer-container
    class="drawer-container"
    [style.--sidenav-width.px]="contentOffset()"
    (backdropClick)="userStore.collapseMenu(true)">
    <mat-drawer
        [opened]="
            userStore.isSmallScreen()
                ? !userStore.menu.isCollapsed() && showHeader() && !userStore.isLoading()
                : showHeader() && !userStore.isLoading()
        "
        [mode]="userStore.isSmallScreen() ? 'over' : 'side'"
        [disableClose]="!userStore.isSmallScreen()"
        [class]="drawerWidthClass()"
        class="drawer-sidenav cipo-bg--primary-50"
        (closedStart)="onDrawerClosed()">
        @if (showHeader() && !userStore.isLoading()) {
            <app-menu [menuItems]="userStore.menu().items"></app-menu>
        }
    </mat-drawer>

    <mat-drawer-content class="drawer-content">
        <div fxLayout="column" class="cipo--height--full">
            @if (showHeader() && !userStore.isLoading()) {
                <app-header fxFlex="none"></app-header>
            }
            <main id="main-content" fxFlex="grow" class="cipo--overflow-y--auto">
                <ng-content></ng-content>
            </main>
        </div>
    </mat-drawer-content>
</mat-drawer-container>
